// Re-export from wrappers (with config injected)
export * from './analytics'
export * from './auth'
export * from './seo'
export * from './ui'

// Re-export from _ui (no config needed)
export * from '@ui/lib/errors'
export * from '@ui/lib/hooks'
export * from '@ui/lib/i18n'
export * from '@ui/lib/i18n/get-dictionary'
export * from '@ui/lib/monitoring'
export * from '@ui/lib/performance'
export * from '@ui/lib/utils'
export { formatDate, formatDateTime } from '@ui/lib/utils/formatDate'

// Project-specific modules (import directly when needed)
// - api/ (server-only)
// - validation/ (project schemas)
